t = require('app/scripts/views/internal/teacup-with-helpers')('attachment_thumb')

module.exports = t.renderable ({
  canReply,
  canUseViewer,
  date,
  edgeColor,
  editable,
  ext,
  imgSrc,
  isCover,
  isHidden,
  name,
  openIconClass,
  openText,
  plugin,
  previewClass,
  removeText,
  url: href,
  upsellEnabled
}) ->
  thumbnailPreviewClasses =
    'attachment-thumbnail-preview': true
    'js-open-viewer': canUseViewer
    'attachment-thumbnail-preview-is-cover': isCover

  if isHidden
    return t.div

  styles = {}
  if imgSrc
    styles['background-image'] = t.urlify(imgSrc)
  if edgeColor
    styles['background-color'] = edgeColor

  t.a { href, class: t.classify(thumbnailPreviewClasses), target: '_blank', title: name, style: t.stylify(styles), rel: 'noreferrer nofollow noopener' }, ->
    if plugin
      pluginPreviewStyle = ""
      if !imgSrc?
        pluginPreviewStyle = "background-image: url(#{plugin.iconUrl});"
      t.span '.attachment-thumbnail-preview-plugin', style: pluginPreviewStyle, ->
        if editable && upsellEnabled
          t.span '.attachment-thumbnail-plugin-enable-link.js-show-power-up-suggestions-info', { title: t.l('see-more-with-power-up', powerUpName: plugin.name) }, ->
            t.icon 'power-up'
            t.format 'get-power-up'
    else if previewClass
        t.span { class: ['attachment-thumbnail-preview-service-logo', previewClass].join(' ') }
    else
      if !imgSrc
        if ext
          t.span '.attachment-thumbnail-preview-ext', ->
            t.text ext
        else
          t.span '.icon-lg.icon-attachment.attachment-thumbnail-preview-attachment-icon'

  titleOptions = ->
    if date
      t.span ->
        t.format 'added', { date }

    if canReply
      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.js-reply', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'comment'

    if editable
      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.dark-hover.js-confirm-delete', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.text removeText

      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.dark-hover.js-edit', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'edit'

  t.p '.attachment-thumbnail-details', {
    class: t.classify(
      'js-open-viewer': canUseViewer
      'js-open-in-new-window': !canUseViewer
    )
  }, ->
    t.span '.attachment-thumbnail-name', ->
      t.text name

    t.a '.attachment-thumbnail-details-title-action.dark-hover.js-attachment-action.js-direct-link', { href, target: '_blank', rel: 'noreferrer nofollow noopener' }, ->
      t.icon openIconClass

    t.span '.u-block.quiet.attachment-thumbnail-details-title-options', -> titleOptions()

    t.span '.quiet.attachment-thumbnail-details-options', ->
      if editable
        t.a '.attachment-thumbnail-details-options-item.dark-hover.hide.js-make-cover', { href: '#' }, ->
          t.icon 'card-cover'
          t.text ' '
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'make-cover'

        t.a '.attachment-thumbnail-details-options-item.dark-hover.hide.js-remove-cover', { href: '#' }, ->
          t.icon 'card-cover'
          t.text ' '
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'remove-cover'

      return
    return
  return
